import { apiSlice } from "../api/apiSlice";
import { setProjects } from "../filter/filterSlice";

export const projectsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProjects: builder.query({
            query: (projects) => {
                return "/projects"
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;
                    const data = result.data.map(single => ({ ...single, show: true }))

                    dispatch(setProjects(data))

                } catch (err) {
                }
            }
        })
    })
})
export const { useGetProjectsQuery } = projectsApi